function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.989 511.989",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m507.606 440.388-30-30c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l4.393 4.393h-42.366c-4.527-12.764-14.656-22.893-27.42-27.42v-102.966c17.933-26.646 60-92.362 60-124.614 0-41.355-33.645-75-75-75s-75 33.645-75 75c0 32.252 42.066 97.967 60 124.614v102.966c-12.764 4.527-22.893 14.656-27.42 27.42h-65.16c-4.527-12.764-14.656-22.893-27.42-27.42v-192.965c17.929-26.638 60-92.362 60-124.614 0-41.355-33.645-75-75-75s-75 33.645-75 75c0 32.252 42.07 97.974 60 124.614v192.966c-12.764 4.527-22.893 14.656-27.42 27.42h-66.16c-4.527-12.764-14.656-22.893-27.42-27.42v-42.966c17.929-26.638 60-92.362 60-124.614 0-41.355-33.645-75-75-75s-75 33.645-75 75c0 32.252 42.07 97.974 60 124.614v42.966c-12.764 4.527-22.893 14.656-27.42 27.42h-17.58c-8.284 0-15 6.716-15 15s6.716 15 15 15h17.58c6.192 17.459 22.865 30 42.42 30s36.228-12.541 42.42-30h66.161c6.192 17.459 22.865 30 42.42 30s36.228-12.541 42.42-30h65.161c6.192 17.459 22.865 30 42.42 30s36.228-12.541 42.42-30h42.367l-4.393 4.393c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.857 15.355 5.858 21.213 0l30-30c5.748-5.749 5.933-15.279-.003-21.213zm-176.606-259.393c0-24.813 20.187-45 45-45s45 20.187 45 45c0 16.383-23.412 59.143-45.002 92.879-21.588-33.725-44.998-76.478-44.998-92.879zm-150-90c0-24.813 20.187-45 45-45s45 20.187 45 45c0 16.383-23.413 59.143-45.002 92.879-21.588-33.725-44.998-76.478-44.998-92.879zm-151 149.999c0-24.813 20.187-45 45-45s45 20.187 45 45c0 16.383-23.411 59.14-45 92.876-21.589-33.736-45-76.492-45-92.876zm45 225c-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15-6.729 15-15 15zm151 0c-8.271 0-15-6.729-15-15 0-8.27 6.728-14.999 14.998-15h.002s.002 0 .002 0c8.27.001 14.998 6.73 14.998 15 0 8.271-6.729 15-15 15zm150 0c-8.268 0-14.994-6.724-15-14.99 0-.003 0-.006 0-.01s0-.006 0-.01c.005-8.267 6.731-14.99 15-14.99 8.271 0 15 6.729 15 15s-6.729 15-15 15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 226,
    cy: 90.995,
    r: 15,
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 75,
    cy: 240.995,
    r: 15,
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 376,
    cy: 180.995,
    r: 15,
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.094cf1524512c63113153db18a413a0f.svg";
export { ForwardRef as ReactComponent };